<template>
  <div class="request">
    <Row
      type="flex"
      justify="space-between"
      align="middle"
      class="request__item request__date"
    >
      <Col>
        <Row type="flex" align="middle">
          <v-icon name="calendar" class-name="icon" />
          <span class="is-title">
            {{ appointmentDateTitle.date }}
          </span>
        </Row>
      </Col>

      <Col>
        <Row type="flex" align="middle">
          <v-icon name="time" class-name="icon" />
          <span class="is-title">
            {{ appointmentDateTitle.time }}
          </span>
        </Row>
      </Col>

      <!-- <Col v-show="type === 'base'">
        <v-button
          bordered
          text="Изменить дату и время"
          @click="changeDateTime"
        />
      </Col> -->
    </Row>

    <div
      class="request__item"
      :class="{ 'request__item--bordered': type === 'base' }"
    >
      <p class="is-subtitle">
        {{ user.is_client ? "Ваш нотариус" : "Клиент" }}
      </p>

      <Row class="user" type="flex" align="middle">
        <img
          class="user__img"
          :src="getImageSrc(partner.avatar_url)"
          v-if="user.is_client"
        />
        <span class="user__name">{{ partner.getFullName() }}</span>
      </Row>

      <template v-if="type === 'base'">
        <Row class="header" type="flex" v-if="!user.is_client">
          <Col :lg="8">
            <p class="is-subtitle">Телефон</p>
            <p>{{ partner.phone }}</p>
          </Col>
          <Col>
            <p class="is-subtitle">Электронная почта</p>
            <p>{{ partner.email }}</p>
          </Col>
        </Row>

        <Row type="flex" justify="space-between" v-else>
          <Col :lg="8">
            <p class="is-subtitle">Адрес</p>
            <p class="p-r-15">{{ partner.getFullAddress() }}</p>
          </Col>
          <Col :lg="8">
            <p class="is-subtitle">Телефон</p>
            <p>{{ partner.phone }}</p>
          </Col>
          <Col :lg="8">
            <p class="is-subtitle">Сайт</p>
            <a :href="partner.getSiteUrl()" class="link" target="_blank">{{
              partner.site_url
            }}</a>
          </Col>
        </Row>
      </template>
    </div>

    <div class="request__item">
      <p class="is-subtitle">Цель обращения</p>
      <p>
        {{ appointment.subject }}
      </p>
    </div>

    <div class="request__item">
      <p class="is-subtitle">Комментарий</p>
      <p>
        {{ appointment.comment }}
      </p>
    </div>

    <div
      v-if="appointment.file_url"
      class="request__item"
    >
      <p class="is-subtitle">
        <a :href="appointment.file_url" target="_blank">Прикрепленный файл</a>
      </p>
    </div>
  </div>
</template>

<script>
import VIcon from "./VIcon";
import VButton from "./VButton";


export default {
  name: "AppointmentRequest",


  components: {
    VIcon,
    VButton
  },


  props: {
    appointment: {
      type: Object,
      default: () => {}
    },
    partner: Object,
    user: Object,
    isModal: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "base"
    }
  },


  data() {
    return {
      visible: true
    };
  },


  computed: {
    appointmentDateTitle() {
      return {
        date: `${this.appointment.getWeek().weekDay}, ${this.appointment.getDay()}`,
        time: this.appointment.getTime(),
      };
    }
  },


  methods: {
    changeDateTime() {
      this.$emit("change-datetime");
    },

    getImageSrc(src) {
      let imgBase = require("@/assets/images/profile-photo-empty.png");
      return src ? src : imgBase;
    }
  }
};
</script>

<style lang="scss">
.request {
  background: $white;

  &__date {
    background: $blue-light;
    padding: 40px;
    .icon {
      margin-right: 20px;
    }
  }

  .user {
    margin-bottom: 40px;
    &__img {
      width: 50px;
      border-radius: 50%;
      margin-right: 20px;
    }
    &__name {
      font-weight: 500;
      font-size: 28px;
    }
  }

  &__item {
    margin-bottom: 40px;
    &--bordered {
      padding-bottom: 40px;
      border-bottom: solid 1px $gray-lighter;
    }

    .is-subtitle {
      margin-bottom: 20px;

      a {
        color: $blue;
      }
    }
  }
}
</style>
